import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/front-pages/shape3.png'
import _imports_1 from '@/assets/images/front-pages/shape5.png'


const _hoisted_1 = { class: "pt-[125px] md:pt-[145px] lg:pt-[185px] xl:pt-[195px] text-center" }
const _hoisted_2 = { class: "container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]" }
const _hoisted_3 = { class: "mb-0 leading-[1.2] text-[32px] md:text-[40px] lg:text-[50px] xl:text-[60px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.pageTitle), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute bottom-0 -z-[1] ltr:-right-[30px] rtl:-left-[30px] blur-[250px]" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "shape3"
        })
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute -top-[220px] -z-[1] ltr:-left-[50px] rtl:-right-[50px] blur-[150px]" }, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: "shape3"
        })
      ], -1))
    ])
  ]))
}